import { createAsyncThunk } from '@reduxjs/toolkit';
import { getAdminAiUsageMonths } from '../../services/getAdminAiUsageMonths.service';

/** Loads the list of months that have any usage, newest first. */
export const loadAdminAiUsageMonths = createAsyncThunk(
  'adminAi/loadAdminAiUsageMonths',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAdminAiUsageMonths();
      return response.months || [];
    } catch (error) {
      // An older API build has no months endpoint; the page then offers the
      // current month only, so this is a warning rather than an error.
      console.warn(
        'AI usage months unavailable, falling back to the current month',
        error
      );
      return rejectWithValue(error.message || 'Failed to load AI usage months');
    }
  }
);
